
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[marketplace]/[solidus_slug]/start",
      function () {
        return require("private-next-pages/[marketplace]/[solidus_slug]/start.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[marketplace]/[solidus_slug]/start"])
      });
    }
  